import * as TYPES from '@app/store/actionTypes';
import SigningProgressType from '@app/store/SigningProgressType';
import { changeTemplateSigningProgressType, TemplateAction } from '@app/store/template/actions';

type TemplateSigningProgressTypeStateType = SigningProgressType;

const initialState: TemplateSigningProgressTypeStateType = 'inOrder';

export default function reducer(
  state: TemplateSigningProgressTypeStateType = initialState,
  action: TemplateAction
) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return initialState;
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
      return action.payload.participants.every((participant) => participant.order === 1)
        ? 'outOfOrder'
        : 'inOrder';
    case changeTemplateSigningProgressType.type:
      return action.payload;
    default:
      return state;
  }
}
